import { useSearchParams } from 'react-router-dom';

import {
  parseRequestedOrganizationId,
  resolveOrganizerBlogMembership,
} from '@/components/blog/resolve-organizer-membership';
import ScopedBlogList from '@/components/blog/scoped-blog-list';
import DashboardLayout from '@/components/layout/DashboardLayout';
import { ROUTES } from '@/config/routes';
import { organizerSidebar } from '@/config/sidebarConfig';
import { useAuthStore } from '@/stores/auth-store';
import { isOrgaForfaitActive } from '@shared';

export default function OrganizerBlog() {
  const user = useAuthStore(s => s.user);
  const [searchParams, setSearchParams] = useSearchParams();
  const memberships = user?.organizationsAdmin ?? [];
  const requested = parseRequestedOrganizationId(searchParams.get('organizationId'));
  const membership = resolveOrganizerBlogMembership(memberships, requested);
  const orgId = membership?.organizationId;
  const isForfaitActive = isOrgaForfaitActive(
    membership?.organization?.plan,
    membership?.organization?.subscriptionStatus,
  );

  if (memberships.length > 1 && !membership) {
    return (
      <DashboardLayout sidebarConfig={organizerSidebar}>
        <div className='p-8'>
          <h1 className='text-xl font-bold text-slate-900'>Blog</h1>
          <p className='mt-2 text-sm text-slate-600'>
            Vous administrez plusieurs organisations. Choisissez celle dont vous gérez le blog.
          </p>
          <ul className='mt-6 space-y-2'>
            {memberships.map(m => (
              <li key={m.organizationId}>
                <button
                  type='button'
                  onClick={() => setSearchParams({ organizationId: String(m.organizationId) })}
                  className='w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-left text-sm font-semibold text-slate-900 hover:border-blue-300 hover:bg-blue-50'
                >
                  {m.organization?.name ?? `Organisation #${m.organizationId}`}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </DashboardLayout>
    );
  }

  const orgQuery = orgId ? `?organizationId=${orgId}` : '';

  return (
    <ScopedBlogList
      sidebarConfig={organizerSidebar}
      createRoute={`${ROUTES.ORGANIZER_BLOG_CREATE}${orgQuery}`}
      editRouteBase='/organizer/blog'
      scopeParams={orgId ? { organizationId: orgId } : undefined}
      subtitle='Articles de votre organisation'
      gate={{
        isAllowed: isForfaitActive,
        title: 'Blog public (Forfait)',
        description: 'Rédigez des articles et publiez sur votre profil public vos dernières actualités.',
        ctaLabel: "Voir l'abonnement",
        ctaTo: '/organizer/settings?tab=subscription',
      }}
    />
  );
}
